import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/pdf.svg'
import _imports_1 from '@/assets/doc.svg'
import _imports_2 from '@/assets/docx.svg'
import _imports_3 from '@/assets/xls.svg'
import _imports_4 from '@/assets/xlsx.svg'
import _imports_5 from '@/assets/txt.svg'
import _imports_6 from '@/assets/png.svg'
import _imports_7 from '@/assets/jpg.svg'
import _imports_8 from '@/assets/jpeg.svg'
import _imports_9 from '@/assets/csv.svg'
import _imports_10 from '@/assets/zip.svg'
import _imports_11 from '@/assets/mp4.svg'
import _imports_12 from '@/assets/link.svg'
import _imports_13 from '@/assets/editdefault.svg'
import _imports_14 from '@/assets/deleteIcon.svg'
import _imports_15 from '@/assets/sortBy.svg'
import _imports_16 from '@/assets/arrowRight.svg'
import _imports_17 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_3 = { class: "flex flex-row justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "items-center justify-between flex"
}
const _hoisted_5 = { class: "title flex items-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "w-full minheight" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_13 = { class: "w-80 heightFixing pr-5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_16 = {
  key: 1,
  class: "h-full"
}
const _hoisted_17 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_18 = { class: "flex flex-row" }
const _hoisted_19 = { class: "border header border-lightgrey w-77 p-2 rounded-tr-md text-xs" }
const _hoisted_20 = { class: "w-full flex flex-row" }
const _hoisted_21 = { class: "w-27 border-b border-l border-lightgrey text-xs p-2" }
const _hoisted_22 = { class: "mt-1" }
const _hoisted_23 = { class: "border-r w-27 border-b border-l border-lightgrey p-2" }
const _hoisted_24 = { class: "pl-3 flex items-center flex-wrap" }
const _hoisted_25 = { class: "flex flex-row" }
const _hoisted_26 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2" }
const _hoisted_27 = { class: "flex flex-row" }
const _hoisted_28 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_29 = { class: "flex flex-row" }
const _hoisted_30 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "flex flex-row" }
const _hoisted_34 = { class: "border-r border-b border-l border-lightgrey w-77 min-w-0 text-xs p-2 text-justify rounded-br-md" }
const _hoisted_35 = {
  key: 0,
  class: "flex gap-3 flex-wrap"
}
const _hoisted_36 = { class: "pdf w-full rounded-sm" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_39 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_40 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_41 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_42 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_43 = {
  key: 5,
  src: _imports_0,
  alt: ""
}
const _hoisted_44 = {
  key: 6,
  src: _imports_5,
  alt: ""
}
const _hoisted_45 = {
  key: 7,
  src: _imports_6,
  alt: ""
}
const _hoisted_46 = {
  key: 8,
  src: _imports_7,
  alt: ""
}
const _hoisted_47 = {
  key: 9,
  src: _imports_8,
  alt: ""
}
const _hoisted_48 = {
  key: 10,
  src: _imports_9,
  alt: ""
}
const _hoisted_49 = {
  key: 11,
  src: _imports_10,
  alt: ""
}
const _hoisted_50 = {
  key: 12,
  src: _imports_11,
  alt: ""
}
const _hoisted_51 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_52 = { class: "ml-2 pb-1" }
const _hoisted_53 = ["title"]
const _hoisted_54 = { class: "flex justify-between w-full" }
const _hoisted_55 = { class: "ml-2 fontSize10PX" }
const _hoisted_56 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_57 = { class: "pdf w-full rounded-sm" }
const _hoisted_58 = ["onClick", "aria-label"]
const _hoisted_59 = { class: "finding-evidence-link-icon__img-wrap" }
const _hoisted_60 = { class: "finding-evidence-link-icon__tooltip" }
const _hoisted_61 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_62 = { class: "ml-2 pb-1" }
const _hoisted_63 = ["title"]
const _hoisted_64 = { class: "flex justify-between w-full" }
const _hoisted_65 = { class: "ml-2 fontSize10PX" }
const _hoisted_66 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "w-full flex flex-row" }
const _hoisted_69 = { class: "w-27 border-b border-l border-lightgrey p-2" }
const _hoisted_70 = {
  key: 0,
  class: "flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-xs border-error p-1 font-semibold"
}
const _hoisted_71 = {
  key: 1,
  class: "flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-xs border-darkred p-1 font-semibold"
}
const _hoisted_72 = {
  key: 2,
  class: "flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-xs border-lightgreen p-1 font-semibold"
}
const _hoisted_73 = {
  key: 3,
  class: "flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-xs border-yellow p-1 font-semibold"
}
const _hoisted_74 = { class: "border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md" }
const _hoisted_75 = {
  key: 0,
  class: "flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor border-solid text-xs border border-lightgreen font-semibold"
}
const _hoisted_76 = {
  key: 1,
  class: "flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor border-solid text-xs border border-darkred font-semibold"
}
const _hoisted_77 = { class: "flex" }
const _hoisted_78 = { class: "w-6/12" }
const _hoisted_79 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_80 = {
  key: 1,
  class: "mt-1 mb-2 text-sm"
}
const _hoisted_81 = { class: "w-6/12" }
const _hoisted_82 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_83 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_84 = { class: "flex" }
const _hoisted_85 = { class: "w-6/12" }
const _hoisted_86 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_87 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_88 = { class: "w-6/12" }
const _hoisted_89 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_90 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_91 = { class: "flex" }
const _hoisted_92 = { class: "w-6/12" }
const _hoisted_93 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_94 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_95 = { class: "w-6/12" }
const _hoisted_96 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_97 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_98 = { class: "flex flex-row" }
const _hoisted_99 = { class: "w-6/12" }
const _hoisted_100 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_101 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_102 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_103 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_104 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_105 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_106 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_107 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_108 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_109 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_110 = { class: "border-b border-lightgrey flex justify-between paddingBottomforApproval mb-5 mt-3" }
const _hoisted_111 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_112 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { class: "border border-lightgrey bg-moderategrey" }
const _hoisted_115 = { class: "w-full flex flex-row" }
const _hoisted_116 = { class: "w-70 p-3 border-x border-lightgrey text-xs text-justify" }
const _hoisted_117 = { class: "w-15 flex items-center justify-center" }
const _hoisted_118 = { class: "flex justify-around w-full" }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "border border-lightgrey" }
const _hoisted_122 = { class: "w-full flex flex-row" }
const _hoisted_123 = { class: "w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center" }
const _hoisted_124 = { class: "w-70 p-3 border-x border-lightgrey text-xs text-justify" }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = { class: "border border-lightgrey bg-moderategrey" }
const _hoisted_127 = { class: "w-full flex flex-row" }
const _hoisted_128 = { class: "w-70 p-3 border-x border-lightgrey text-xs text-justify" }
const _hoisted_129 = { class: "border-b border-x border-lightgrey" }
const _hoisted_130 = { class: "w-full flex flex-row" }
const _hoisted_131 = { class: "w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = { class: "w-15 p-3 flex flex-row items-center justify-center" }
const _hoisted_134 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_135 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_136 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_137 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_138 = { class: "comment-box w-full mt-5" }
const _hoisted_139 = { class: "comments" }
const _hoisted_140 = { class: "initials" }
const _hoisted_141 = { class: "w-1/5" }
const _hoisted_142 = { class: "header" }
const _hoisted_143 = { class: "fontSize10PX" }
const _hoisted_144 = { class: "w-4/5 text-xs text-justify" }
const _hoisted_145 = {
  key: 3,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_146 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_147 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_148 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_149 = { class: "flex" }
const _hoisted_150 = {
  key: 0,
  class: "initials"
}
const _hoisted_151 = {
  key: 1,
  class: "initials"
}
const _hoisted_152 = { class: "logContainer w-93" }
const _hoisted_153 = { class: "flex mt-1" }
const _hoisted_154 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_155 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_156 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_157 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_158 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_159 = {
  key: 5,
  class: "font-semibold text-xs"
}
const _hoisted_160 = {
  key: 6,
  class: "font-semibold text-xs"
}
const _hoisted_161 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_162 = {
  key: 0,
  class: "flex"
}
const _hoisted_163 = { class: "text-xs w-full text-justify" }
const _hoisted_164 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_165 = {
  key: 0,
  class: "font-semibold text-xs w-18"
}
const _hoisted_166 = {
  key: 1,
  class: "font-semibold text-xs w-18"
}
const _hoisted_167 = {
  key: 2,
  class: "font-semibold text-xs w-18"
}
const _hoisted_168 = { class: "text-xs w-82 text-justify" }
const _hoisted_169 = {
  key: 2,
  class: "flex"
}
const _hoisted_170 = { class: "mx-2 text-xs text-justify" }
const _hoisted_171 = {
  key: 3,
  class: "flex"
}
const _hoisted_172 = { class: "mx-2 text-xs text-justify" }
const _hoisted_173 = {
  key: 4,
  class: "flex"
}
const _hoisted_174 = { class: "mx-2 text-xs text-justify" }
const _hoisted_175 = {
  key: 5,
  class: "flex"
}
const _hoisted_176 = { key: 6 }
const _hoisted_177 = { class: "flex items-center" }
const _hoisted_178 = { class: "flex ml-4" }
const _hoisted_179 = {
  key: 0,
  class: "mt-1 text-xs"
}
const _hoisted_180 = { class: "font-semibold ml-1" }
const _hoisted_181 = {
  key: 4,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_182 = { class: "border-b border-lightgrey flex justify-between paddingBottomforApproval mt-3" }
const _hoisted_183 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_184 = {
  key: 0,
  class: "initials"
}
const _hoisted_185 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_186 = {
  key: 2,
  class: "initials"
}
const _hoisted_187 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_188 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_189 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_190 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_191 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_192 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_193 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_194 = { class: "m-3" }
const _hoisted_195 = { key: 0 }
const _hoisted_196 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_197 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_198 = { class: "flex flex-col" }
const _hoisted_199 = {
  key: 0,
  disabled: "",
  type: "text",
  placeholder: "Status",
  class: "terminateBox inputboxstyling mt-2 mb-3",
  value: "Terminated"
}
const _hoisted_200 = { key: 1 }
const _hoisted_201 = { key: 0 }
const _hoisted_202 = { class: "mt-2" }
const _hoisted_203 = { key: 1 }
const _hoisted_204 = { class: "mt-3" }
const _hoisted_205 = { class: "my-1 mt-2" }
const _hoisted_206 = { class: "mt-3" }
const _hoisted_207 = { class: "my-1 mt-2" }
const _hoisted_208 = { class: "mt-3" }
const _hoisted_209 = { class: "my-1 mt-2" }
const _hoisted_210 = { class: "mt-3" }
const _hoisted_211 = { class: "my-1" }
const _hoisted_212 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_213 = { class: "flex flex-col h-full" }
const _hoisted_214 = { class: "flex-1 overflow-auto" }
const _hoisted_215 = { class: "formcontainer px-4 pb-4 flex flex-col" }
const _hoisted_216 = { class: "flex-1 overflow-auto" }
const _hoisted_217 = { class: "row flex flex-row mt-3" }
const _hoisted_218 = { class: "w-full" }
const _hoisted_219 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_220 = {
  key: 0,
  class: "error-text"
}
const _hoisted_221 = { class: "flex justify-end items-center mt-2" }
const _hoisted_222 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_223 = { class: "w-full flex flex-row" }
const _hoisted_224 = { class: "w-95 mr-5" }
const _hoisted_225 = ["onUpdate:modelValue"]
const _hoisted_226 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_227 = { class: "w-5" }
const _hoisted_228 = { class: "flex items-center justify-center h-full" }
const _hoisted_229 = ["onClick"]
const _hoisted_230 = { class: "w-1/2 mt-3" }
const _hoisted_231 = ["onUpdate:modelValue", "max"]
const _hoisted_232 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_233 = {
  key: 0,
  class: "flex items-center justify-end pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_234 = ["disabled"]
const _hoisted_235 = {
  key: 1,
  class: "flex items-center justify-end pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_236 = ["disabled"]
const _hoisted_237 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_238 = { class: "flex flex-col h-full" }
const _hoisted_239 = { class: "flex-1 overflow-auto" }
const _hoisted_240 = { class: "statuscontainer px-5 pb-5" }
const _hoisted_241 = { class: "formcontainer flex flex-col" }
const _hoisted_242 = { class: "row flex flex-row mt-3" }
const _hoisted_243 = { class: "w-1/2" }
const _hoisted_244 = {
  class: "inputboxstyling mt-2",
  disabled: ""
}
const _hoisted_245 = { class: "row flex flex-row mt-3" }
const _hoisted_246 = { class: "w-full" }
const _hoisted_247 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_248 = ["disabled"]
const _hoisted_249 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_250 = { class: "flex flex-col h-full" }
const _hoisted_251 = { class: "flex-1 overflow-auto" }
const _hoisted_252 = { class: "statuscontainer px-5 py-5" }
const _hoisted_253 = { class: "formcontainer flex flex-col w-full" }
const _hoisted_254 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_255 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_ctx.dotsLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_dots_loader)
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal finding-details-in-modal' : 'mb-5 mx-5 mt-3')
      }, [
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.modalMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.presentFindingObject.findingComment!=undefined?_ctx.presentFindingObject.findingComment:'N/A'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6)),
            (_ctx.approvalObj.statusCode == 10401 && _ctx.checkAuditor(_ctx.presentFindingObject.auditor))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btnprimary items-center btnPrimaryPadding mr-2",
                    disabled: _ctx.clickOnButtonForRejectingApproval,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrReject(10403)))
                  }, "Approve", 8, _hoisted_8),
                  _createElementVNode("button", {
                    class: "btnprimary items-center btnPrimaryPadding",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopupToReject()))
                  }, "Reject")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Tabs, {
                    value: _ctx.selectedTabIndex,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
                    scrollable: "",
                    class: "heightFixing"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_TabList, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                              return (_openBlock(), _createBlock(_component_Tab, {
                                key: tab.id,
                                value: tab.id,
                                onClick: ($event: any) => (_ctx.toggleTabs(tab))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tab.displayName), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                            return (_openBlock(), _createBlock(_component_TabPanel, {
                              key: tab.id,
                              value: tab.id
                            }, {
                              default: _withCtx(() => [
                                (_ctx.tabDataLoading == true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createVNode(_component_dots_loader)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      (tab.id == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _cache[51] || (_cache[51] = _createElementVNode("div", null, [
                                              _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between mb-5 paddingBottomForFindings mt-3" }, [
                                                _createElementVNode("div", { class: "marginBottom1px flex items-center justify-center" }, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", { class: "header mt-0.5" }, "Finding Information")
                                                  ])
                                                ])
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_18, [
                                                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Finding ID", -1)),
                                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.presentFindingObject.findingId), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_20, [
                                                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Framework", -1)),
                                                _createElementVNode("div", _hoisted_21, [
                                                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.presentFindingObject.frameworks), 1)
                                                ]),
                                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Control Number", -1)),
                                                _createElementVNode("div", _hoisted_23, [
                                                  _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass([_ctx.getBorder(), "text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center"])
                                                    }, _toDisplayString(_ctx.presentFindingObject.frameWorkControl), 3)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_25, [
                                                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Control Title", -1)),
                                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.presentFindingObject.frameworkControlTitle ? _ctx.presentFindingObject.frameworkControlTitle : 'N/A'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_27, [
                                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding", -1)),
                                                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.presentFindingObject.findingComment), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_29, [
                                                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding Severity", -1)),
                                                _createElementVNode("div", _hoisted_30, [
                                                  (_ctx.getFindingSeverityValue(_ctx.presentFindingObject) != null)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.findingSeverityChipBg(_ctx.presentFindingObject)]),
                                                        title: _ctx.getFindingSeverityLabel(_ctx.presentFindingObject)
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText(_ctx.presentFindingObject)])
                                                        }, _toDisplayString(_ctx.getFindingSeverityLabel(_ctx.presentFindingObject)), 3)
                                                      ], 10, _hoisted_31))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "N/A"))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_33, [
                                                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey flex items-center" }, " Evidence ", -1)),
                                                _createElementVNode("div", _hoisted_34, [
                                                  (_ctx.findingFileEvidences.length || _ctx.findingLinkEvidences.length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingFileEvidences, (doc, idx) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: 'finding-file-'+idx
                                                          }, [
                                                            _createElementVNode("div", _hoisted_36, [
                                                              _createElementVNode("a", {
                                                                href: "#",
                                                                onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                class: "flex w-full flex-row items-center cursor-pointer"
                                                              }, [
                                                                ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='png')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_48))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                                                                  : _createCommentVNode("", true),
                                                                ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                                  ? (_openBlock(), _createElementBlock("img", _hoisted_50))
                                                                  : _createCommentVNode("", true),
                                                                _createElementVNode("div", _hoisted_51, [
                                                                  _createElementVNode("div", _hoisted_52, [
                                                                    _createElementVNode("p", {
                                                                      class: "text-xs font-medium truncate",
                                                                      title: doc.filename || doc.name
                                                                    }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_53)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_54, [
                                                                    _createElementVNode("p", _hoisted_55, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                    _createElementVNode("p", _hoisted_56, _toDisplayString(doc.taskId?doc.taskId:'N/A'), 1)
                                                                  ])
                                                                ])
                                                              ], 8, _hoisted_37)
                                                            ])
                                                          ]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingLinkEvidences, (doc, idx) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: 'finding-link-'+idx
                                                          }, [
                                                            _createElementVNode("div", _hoisted_57, [
                                                              _createElementVNode("a", {
                                                                href: "#",
                                                                onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                class: "flex w-full flex-row items-center cursor-pointer finding-evidence-link-icon",
                                                                "aria-label": doc.url
                                                              }, [
                                                                _createElementVNode("span", _hoisted_59, [
                                                                  _cache[35] || (_cache[35] = _createElementVNode("img", {
                                                                    src: _imports_12,
                                                                    alt: "Link",
                                                                    class: "finding-evidence-link-icon__img"
                                                                  }, null, -1)),
                                                                  _createElementVNode("span", _hoisted_60, _toDisplayString(doc.url), 1)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_61, [
                                                                  _createElementVNode("div", _hoisted_62, [
                                                                    _createElementVNode("p", {
                                                                      class: "text-xs font-medium truncate",
                                                                      title: doc.filename || doc.name
                                                                    }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_63)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_64, [
                                                                    _createElementVNode("p", _hoisted_65, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                    _createElementVNode("p", _hoisted_66, _toDisplayString(doc.taskId?doc.taskId:'N/A'), 1)
                                                                  ])
                                                                ])
                                                              ], 8, _hoisted_58)
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.presentFindingObject.findingEvidence), 1))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_68, [
                                                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md" }, "Finding Category", -1)),
                                                _createElementVNode("div", _hoisted_69, [
                                                  (_ctx.presentFindingObject.findingCategory === 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject.findingCategory)), 1))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.presentFindingObject.findingCategory === 2)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject.findingCategory)), 1))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.presentFindingObject.findingCategory === 3)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject.findingCategory)), 1))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.presentFindingObject.findingCategory === 4)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject.findingCategory)), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Control Audit Result", -1)),
                                                _createElementVNode("div", _hoisted_74, [
                                                  (_ctx.presentFindingObject.auditResult === 'Pass')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(_ctx.presentFindingObject.auditResult), 1))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.presentFindingObject.auditResult === 'Fail')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.presentFindingObject.auditResult), 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[41] || (_cache[41] = _createElementVNode("div", null, [
                                                _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                  _createElementVNode("p", { class: "mt-4 mb-1.5 header" }, "Control Information")
                                                ])
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("div", _hoisted_78, [
                                                  _cache[39] || (_cache[39] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "CID", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.clientUniqueId!=undefined)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_ctx.presentFindingObject.controlInfo!=undefined&&_ctx.presentFindingObject.controlInfo[0]?.clientUniqueId!='' ? _ctx.presentFindingObject.controlInfo[0]?.clientUniqueId : 'N/A'), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_80, "N/A"))
                                                ]),
                                                _createElementVNode("div", _hoisted_81, [
                                                  _cache[40] || (_cache[40] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "Frequency", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject !=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo[0]?.controlFrequency!=undefined)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_82, _toDisplayString(_ctx.dbFrequency.find((l) => l.value == _ctx.presentFindingObject.controlInfo[0]?.controlFrequency)?.key), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_83, "N/A"))
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_84, [
                                              _createElementVNode("div", _hoisted_85, [
                                                _cache[42] || (_cache[42] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject !=undefined && _ctx.presentFindingObject.controlInfo &&_ctx.presentFindingObject.controlInfo.length>0 && _ctx.presentFindingObject.controlInfo[0]?.controlTitle!=undefined )
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlTitle), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_87, "N/A"))
                                              ]),
                                              _createElementVNode("div", _hoisted_88, [
                                                _cache[43] || (_cache[43] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Type", -1)),
                                                (_ctx.presentFindingObject?.controlInfo?.length > 0 && _ctx.presentFindingObject.controlInfo[0]?.controlType)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlType || 'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_90, "N/A"))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_91, [
                                              _createElementVNode("div", _hoisted_92, [
                                                _cache[44] || (_cache[44] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Class", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.controlClass!=undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlClass||'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_94, "N/A"))
                                              ]),
                                              _createElementVNode("div", _hoisted_95, [
                                                _cache[45] || (_cache[45] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Family", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.controlFamily!=undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlFamily||'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_97, "N/A"))
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_98, [
                                              _createElementVNode("div", _hoisted_99, [
                                                _cache[46] || (_cache[46] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.controlPriority!=undefined && typeof _ctx.presentFindingObject.controlInfo[0]?.controlPriority === 'number')
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentFindingObject.controlInfo[0]?.controlPriority)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentFindingObject.controlInfo[0]?.controlPriority)])
                                                      }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentFindingObject.controlInfo[0]?.controlPriority)), 3)
                                                    ], 2))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_100, "N/A"))
                                              ])
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                              (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.Description!=undefined)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(_ctx.presentFindingObject.controlInfo[0]?.Description||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_102, "N/A"))
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                              (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.controlPolicies!=undefined)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_103, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlPolicies||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_104, "N/A"))
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Guidance", -1)),
                                              (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.controlGuidance!=undefined)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_105, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlGuidance||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_106, "N/A"))
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[50] || (_cache[50] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                              (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.controlInfo && _ctx.presentFindingObject.controlInfo.length>0&& _ctx.presentFindingObject.controlInfo[0]?.controlMaintenanceTask!=undefined)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(_ctx.presentFindingObject.controlInfo[0].controlMaintenanceTask||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_108, "N/A"))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (tab.id == 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_110, [
                                                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", { class: "header" }, "Cause & Action")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", _hoisted_111, [
                                                    _createElementVNode("div", _hoisted_112, [
                                                      _createElementVNode("button", {
                                                        class: _normalizeClass((_ctx.presentFindingObject.auditee != _ctx.userInfo._id && _ctx.newTeamAssignee.value != _ctx.userInfo._id && this.userInfo.organisationType!=10701) || _ctx.TaskDetailsDropDown.findingStatus == 10418 || _ctx.approvalObj.statusCode == 10422 || _ctx.presentFindingObject.auditor == _ctx.userInfo._id || _ctx.presentFindingObject.statusCode == 10421  || !_ctx.isAddDisabled(10302) ? 'btndisabled pointer-events-none' : 'filterButton'),
                                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCausePopup()))
                                                      }, " Add Cause ", 2)
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            (_ctx.presentFindingObject.causes != undefined  && _ctx.presentFindingObject.tasks == undefined)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingObject.causes, (cause, number) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "mb-3",
                                                      key: number
                                                    }, [
                                                      _createElementVNode("div", _hoisted_114, [
                                                        _createElementVNode("div", _hoisted_115, [
                                                          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center" }, "Cause for this Finding ", -1)),
                                                          _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.presentFindingObject.causes[number].cause), 1),
                                                          _createElementVNode("div", _hoisted_117, [
                                                            _createElementVNode("div", _hoisted_118, [
                                                              _createElementVNode("img", {
                                                                src: _imports_13,
                                                                class: _normalizeClass(["cursor-pointer", _ctx.TaskDetailsDropDown.findingStatus == 10421 ? 'hidden' : '' ]),
                                                                onClick: ($event: any) => (_ctx.editCauseAndAction(cause))
                                                              }, null, 10, _hoisted_119),
                                                              _createElementVNode("img", {
                                                                src: _imports_14,
                                                                class: _normalizeClass(["cursor-pointer", _ctx.TaskDetailsDropDown.findingStatus == 10421 ? 'hidden' : '' ]),
                                                                onClick: ($event: any) => (_ctx.deleteCauseAndAction(cause.causeId, cause.cause))
                                                              }, null, 10, _hoisted_120)
                                                            ])
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("ul", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cause.actions, (action, index) => {
                                                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                                                            _createElementVNode("div", _hoisted_121, [
                                                              _createElementVNode("div", _hoisted_122, [
                                                                _createElementVNode("div", _hoisted_123, "Action" + _toDisplayString(index + 1) + " for this Finding ", 1),
                                                                _createElementVNode("div", _hoisted_124, _toDisplayString(action.action), 1),
                                                                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "w-15 p-3 flex flex-row items-center justify-center" }, [
                                                                  _createElementVNode("div", { class: "flex items-center justify-center rounded h-5 w-24 bg-lightgrey border-solid border border-disabledgrey" }, [
                                                                    _createElementVNode("div", { class: "font-semibold text-xs text-disabledgrey" }, " Not Started ")
                                                                  ])
                                                                ], -1))
                                                              ])
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : (_ctx.presentFindingObject.tasks != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalFindingsTasks, (task, number) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        class: "mb-3",
                                                        key: number
                                                      }, [
                                                        _createElementVNode("div", _hoisted_126, [
                                                          _createElementVNode("div", _hoisted_127, [
                                                            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center" }, "Cause for this Finding ", -1)),
                                                            _createElementVNode("div", _hoisted_128, _toDisplayString(number), 1),
                                                            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "w-15 flex items-center justify-center p-3" }, [
                                                              _createElementVNode("div", { class: "flex items-center justify-center rounded h-5 w-24 evidenceUpload border-solid border border-primary" }, [
                                                                _createElementVNode("div", { class: "font-semibold text-xs text-primary" }, " Approved ")
                                                              ])
                                                            ], -1))
                                                          ])
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task, (task1, num) => {
                                                          return (_openBlock(), _createElementBlock("div", { key: num }, [
                                                            _createElementVNode("ul", null, [
                                                              _createElementVNode("li", null, [
                                                                _createElementVNode("div", _hoisted_129, [
                                                                  _createElementVNode("div", _hoisted_130, [
                                                                    _createElementVNode("div", _hoisted_131, "Action" + _toDisplayString(num + 1) + " for this Finding", 1),
                                                                    _createElementVNode("div", {
                                                                      class: "w-70 p-3 border-x border-lightgrey text-xs text-justify cursor-pointer",
                                                                      onClick: ($event: any) => (_ctx.goToActionTasks(task1._id))
                                                                    }, _toDisplayString(task1.action), 9, _hoisted_132),
                                                                    _createElementVNode("div", _hoisted_133, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorFindingBg(task1.statusCode)])
                                                                      }, [
                                                                        _createElementVNode("div", {
                                                                          class: _normalizeClass(["text-xs", _ctx.colorFindingText(task1.statusCode)])
                                                                        }, _toDisplayString(_ctx.getStatusLabel(task1.statusCode)), 3)
                                                                      ], 2)
                                                                    ])
                                                                  ])
                                                                ])
                                                              ])
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (tab.id == 3)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_135, [
                                                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", { class: "header" }, "Comments")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", _hoisted_136, [
                                                    _createElementVNode("div", _hoisted_137, [
                                                      (_ctx.oldComments)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "filterButton w-24 flex",
                                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortComments()))
                                                          }, _cache[57] || (_cache[57] = [
                                                            _createElementVNode("img", {
                                                              src: _imports_15,
                                                              class: "h-3 mr-2.5"
                                                            }, null, -1),
                                                            _createTextVNode(" Oldest ")
                                                          ])))
                                                        : _createCommentVNode("", true),
                                                      (!_ctx.oldComments)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 1,
                                                            class: "filterButton w-24 flex",
                                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortComments()))
                                                          }, _cache[58] || (_cache[58] = [
                                                            _createElementVNode("img", {
                                                              src: _imports_15,
                                                              class: "h-3 mr-2.5 rotate-180"
                                                            }, null, -1),
                                                            _createTextVNode(" Newest ")
                                                          ])))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_138, [
                                                  (_ctx.TaskDetailsDropDown.taskStatus!=10422  && _ctx.TaskDetailsDropDown.taskStatus!=10418 && _ctx.TaskDetailsDropDown.taskStatus!=10417 && _ctx.isAddDisabled(10302))
                                                    ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                                        key: 0,
                                                        taskStatusCode: _ctx.TaskDetailsDropDown.taskStatus
                                                      }, null, 8, ["taskStatusCode"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_139, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingObject.comments, (comment, number) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: number,
                                                      class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-3"
                                                    }, [
                                                      _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.extractInitials((comment.name) )), 1),
                                                      _createElementVNode("div", _hoisted_141, [
                                                        _createElementVNode("div", _hoisted_142, _toDisplayString(comment.name), 1),
                                                        _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.presentFindingObject.createdAt), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_144, [
                                                        _createVNode(_component_safeHtml, {
                                                          content: comment.comment
                                                        }, null, 8, ["content"])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (tab.id == 5)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_146, [
                                                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", { class: "header" }, "WorkLog")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", _hoisted_147, [
                                                    _createElementVNode("div", _hoisted_148, [
                                                      (_ctx.oldHistory)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "filterButton w-24 flex",
                                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortHistory()))
                                                          }, _cache[60] || (_cache[60] = [
                                                            _createElementVNode("img", {
                                                              src: _imports_15,
                                                              class: "h-3 mr-2.5"
                                                            }, null, -1),
                                                            _createTextVNode(" Oldest ")
                                                          ])))
                                                        : _createCommentVNode("", true),
                                                      (!_ctx.oldHistory)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 1,
                                                            class: "filterButton w-24 flex",
                                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortHistory()))
                                                          }, _cache[61] || (_cache[61] = [
                                                            _createElementVNode("img", {
                                                              src: _imports_15,
                                                              class: "h-3 mr-2.5 rotate-180"
                                                            }, null, -1),
                                                            _createTextVNode(" Newest ")
                                                          ])))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ])
                                              ]),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.findingHistory, (work) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: work,
                                                  class: "bg-white py-4 pl-4 mb-0.5 border-lightgrey border-b w-full"
                                                }, [
                                                  _createElementVNode("div", _hoisted_149, [
                                                    (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_150, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('updatedBy'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_152, [
                                                      _createElementVNode("div", _hoisted_153, [
                                                        (Object.keys(work).includes('createdBy'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_154, _toDisplayString(work.name), 1))
                                                          : (Object.keys(work).includes('updatedBy'))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_155, _toDisplayString(work.name), 1))
                                                            : _createCommentVNode("", true),
                                                        (work.actionEntity == 10301)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_156, _toDisplayString('Created the Finding on')))
                                                          : (work.statusCode != undefined && work.statusCode == 10418)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_157, _toDisplayString('Terminated the Finding on')))
                                                            : (work.actionEntity == 10302)
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_158, _toDisplayString('Updated the Finding on')))
                                                              : _createCommentVNode("", true),
                                                        (Object.keys(work).includes('createdAt'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_159, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work).includes('updatedAt'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_160, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      (Object.keys(work).includes('additionalInfo'))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                                            (work.additionalInfo.comment)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                                                  _cache[63] || (_cache[63] = _createElementVNode("div", { class: "font-semibold text-xs widthForCommentBox" }, "Comment :", -1)),
                                                                  _createElementVNode("div", _hoisted_163, [
                                                                    _createVNode(_component_safeHtml, {
                                                                      content: work.additionalInfo.comment
                                                                    }, null, 8, ["content"])
                                                                  ])
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (work.additionalInfo.cause)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                                                  (work.additionalInfo.action == 10301)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_165, "Created the Cause :"))
                                                                    : (work.additionalInfo.action == 10302)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_166, "Updated the Cause :"))
                                                                      : (work.additionalInfo.action == 10303)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_167, "Deleted the Cause :"))
                                                                        : _createCommentVNode("", true),
                                                                  _createElementVNode("div", _hoisted_168, _toDisplayString(work.additionalInfo.cause), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (Object.keys(work.additionalInfo).includes('assignee'))
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                                                  _cache[64] || (_cache[64] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                                  _createElementVNode("p", _hoisted_170, _toDisplayString(_ctx.getPersonName(work.additionalInfo.assignee)), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (Object.keys(work.additionalInfo).includes('approver'))
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                                                  _cache[65] || (_cache[65] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Sent Approval for -'), -1)),
                                                                  _createElementVNode("p", _hoisted_172, _toDisplayString(_ctx.getPersonName(work.additionalInfo.approver)), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (work.additionalInfo.approvalStatusCode == 10410)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                                                  _cache[66] || (_cache[66] = _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Approval is Rejected - '), -1)),
                                                                  _createElementVNode("p", _hoisted_174, _toDisplayString(work.additionalInfo.justification||'N/A'), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (work.additionalInfo.approvalStatusCode == 10422)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_175, _cache[67] || (_cache[67] = [
                                                                  _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Approval is Accepted'), -1)
                                                                ])))
                                                              : _createCommentVNode("", true),
                                                            (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                                                  _createElementVNode("div", _hoisted_177, [
                                                                    _cache[69] || (_cache[69] = _createElementVNode("div", null, [
                                                                      _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Updated The Status :'))
                                                                    ], -1)),
                                                                    _createElementVNode("div", _hoisted_178, [
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.previousStatus)])
                                                                      }, [
                                                                        _createElementVNode("div", {
                                                                          class: _normalizeClass(["text-xs", _ctx.colorFindingText(work.additionalInfo.previousStatus)])
                                                                        }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                      ], 2),
                                                                      _cache[68] || (_cache[68] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                        _createElementVNode("img", { src: _imports_16 })
                                                                      ], -1)),
                                                                      _createElementVNode("div", {
                                                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.updatedStatus)])
                                                                      }, [
                                                                        _createElementVNode("div", {
                                                                          class: _normalizeClass(["text-xs", _ctx.colorFindingText(work.additionalInfo.updatedStatus)])
                                                                        }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                      ], 2)
                                                                    ])
                                                                  ]),
                                                                  ((work.additionalInfo.previousStatus == 10406 || work.additionalInfo.previousStatus == 10402) && (work.additionalInfo.updatedStatus == 10406 || work.additionalInfo.updatedStatus==10422) && work.additionalInfo.taskId)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                                                        _cache[70] || (_cache[70] = _createTextVNode(" ID:")),
                                                                        _createElementVNode("span", _hoisted_180, _toDisplayString(work.additionalInfo.taskId), 1),
                                                                        _cache[71] || (_cache[71] = _createTextVNode(" is completed "))
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (tab.id == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_182, [
                                                _cache[72] || (_cache[72] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", { class: "header" }, "Approvals")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", _hoisted_183, [
                                                    _createElementVNode("button", {
                                                      class: _normalizeClass(["flex", (_ctx.presentFindingObject.auditee != _ctx.userInfo._id && _ctx.newTeamAssignee.value != _ctx.userInfo._id && this.userInfo.organisationType!=10701) || _ctx.causesLength == true || _ctx.approvalObj.statusCode == 10401 || _ctx.approvalObj.statusCode == 10422 || _ctx.presentFindingObject.auditor == _ctx.userInfo._id  ? 'btndisabled pointer-events-none' : 'filterButton']),
                                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openApprovalpopup()))
                                                    }, " Send Approval ", 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingObject.approvals, (approval, number) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: number,
                                                    class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                                  }, [
                                                    (approval.createdBy != undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_184, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                      : _createCommentVNode("", true),
                                                    (approval.createdBy != undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_185, _toDisplayString(approval.name), 1))
                                                      : _createCommentVNode("", true),
                                                    (approval.updatedBy != undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                      : _createCommentVNode("", true),
                                                    (approval.updatedBy != undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(approval.name), 1))
                                                      : _createCommentVNode("", true),
                                                    (approval.statusCode == 10401)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_188, _toDisplayString(' Requested an approval ')))
                                                      : (approval.statusCode == 10410)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_189, _toDisplayString(' Rejected an approval ')))
                                                        : (approval.statusCode == 10403)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_190, _toDisplayString(' Approved an approval ')))
                                                          : _createCommentVNode("", true),
                                                    (approval.createdAt != undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_191, _toDisplayString(_ctx.formatTime(approval.createdAt)), 1))
                                                      : _createCommentVNode("", true),
                                                    (approval.updatedAt != undefined)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_192, _toDisplayString(_ctx.formatTime(approval.updatedAt)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_193, [
                  _createElementVNode("div", _hoisted_194, [
                    _cache[83] || (_cache[83] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                      _createElementVNode("h1", null, "Finding Details")
                    ], -1)),
                    (_ctx.tabDataLoading == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                          _createElementVNode("div", _hoisted_196, [
                            _createVNode(_component_dots_loader)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_197, [
                          _createElementVNode("div", _hoisted_198, [
                            _cache[73] || (_cache[73] = _createElementVNode("label", { class: "controllabel" }, "Finding Status", -1)),
                            (_ctx.TaskDetailsDropDown.findingStatus == 10418)
                              ? (_openBlock(), _createElementBlock("input", _hoisted_199))
                              : (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                  _createVNode(_component_Select, {
                                    appendTo: "body",
                                    modelValue: _ctx.TaskDetailsDropDown.findingStatus,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.TaskDetailsDropDown.findingStatus) = $event)),
                                    options: _ctx.findingStatusData,
                                    optionLabel: "status",
                                    optionValue: "id",
                                    placeholder: "Please select one",
                                    class: _normalizeClass(["custom-select w-full mt-2 mb-3 px-2.5 py-1 text-sm font-light text-gray rounded-sm border border-lightgrey", _ctx.changeBackground()]),
                                    disabled: true,
                                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateFindingStatus(_ctx.TaskDetailsDropDown.findingStatus)))
                                  }, null, 8, ["modelValue", "options", "class"])
                                ]))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _cache[74] || (_cache[74] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                              ((_ctx.newTeamAssignee.value != _ctx.userInfo._id  && _ctx.presentFindingObject.auditee == _ctx.userInfo._id) || _ctx.TaskDetailsDropDown.taskStatus == 10422|| _ctx.TaskDetailsDropDown.taskStatus == 10422 || _ctx.presentFindingObject.statusCode == 10403|| _ctx.presentFindingObject.statusCode == 10418 || _ctx.presentFindingObject.tasks != undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                    _createElementVNode("p", _hoisted_202, _toDisplayString(_ctx.newTeamAssignee.label), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                    _createVNode(_component_AutoComplete, {
                                      appendTo: "body",
                                      modelValue: _ctx.presentFindingObject.assignee,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.presentFindingObject.assignee) = $event)),
                                      suggestions: _ctx.userOptions,
                                      placeholder: "Assigned-To",
                                      optionLabel: "label",
                                      field: "label",
                                      class: "w-full custom-autocomplete userSelect mt-2",
                                      onComplete: _ctx.asyncFind,
                                      onItemSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentFindingObject.assignee)))
                                    }, null, 8, ["modelValue", "suggestions", "onComplete"])
                                  ]))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_204, [
                            _cache[75] || (_cache[75] = _createElementVNode("label", { class: "controllabel" }, "Auditor", -1)),
                            _cache[76] || (_cache[76] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", _hoisted_205, _toDisplayString(_ctx.getPerson(_ctx.presentFindingObject.auditor)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_206, [
                            _cache[77] || (_cache[77] = _createElementVNode("label", { class: "controllabel" }, "Auditee", -1)),
                            _cache[78] || (_cache[78] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", _hoisted_207, _toDisplayString(_ctx.getAllPersonName(_ctx.presentFindingObject.auditee)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_208, [
                            _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                            _cache[80] || (_cache[80] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", _hoisted_209, _toDisplayString(_ctx.getTeamName(_ctx.presentFindingObject.department)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_210, [
                            _cache[81] || (_cache[81] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                            _cache[82] || (_cache[82] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", _hoisted_211, _toDisplayString(_ctx.getLocationName(_ctx.presentFindingObject.department)), 1)
                          ])
                        ]))
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.showCausePopup)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 1,
              popUp: _ctx.showCausePopup
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_212, [
                  _cache[85] || (_cache[85] = _createElementVNode("h1", null, "Cause and Action", -1)),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onCrossbtnForCauseAndAction()))
                  }, _cache[84] || (_cache[84] = [
                    _createElementVNode("img", {
                      src: _imports_17,
                      class: "cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_213, [
                  _createElementVNode("div", _hoisted_214, [
                    _createElementVNode("div", _hoisted_215, [
                      _createElementVNode("div", _hoisted_216, [
                        _createElementVNode("div", _hoisted_217, [
                          _createElementVNode("div", _hoisted_218, [
                            _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel" }, "Cause", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.causeActionObj.cause.$error }]),
                              type: "text",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.causeActionObj.cause) = $event)),
                              placeholder: "Cause for the Finding"
                            }, null, 2), [
                              [
                                _vModelText,
                                _ctx.causeActionObj.cause,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.causeActionObj.cause.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                                  (_ctx.v$.causeActionObj.cause.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_220, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_221, [
                          _createElementVNode("button", {
                            class: "btnprimary",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addTextarea()))
                          }, "Add")
                        ]),
                        _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Actions", -1)),
                        (_ctx.textareas.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_222, _cache[87] || (_cache[87] = [
                              _createElementVNode("div", { class: "error-text" }, "Enter atleast one Action", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textareas, (textarea, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mb-2",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_223, [
                              _createElementVNode("div", _hoisted_224, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: _normalizeClass(["inputboxstyling mt-2", {
                                    'is-invalid borderRed':
                                        _ctx.v$.textareas.$dirty &&
                                        !_ctx.v$.textareas.$each.$response.$data[index].action.required,
                                    }]),
                                  "onUpdate:modelValue": ($event: any) => ((textarea.action) = $event),
                                  placeholder: "Add an action for this Cause",
                                  rows: "3"
                                }, null, 10, _hoisted_225), [
                                  [
                                    _vModelText,
                                    textarea.action,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (
                                    _ctx.v$.textareas.$dirty &&
                                    !_ctx.v$.textareas.$each.$response.$data[index].action.required
                                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_226, _cache[88] || (_cache[88] = [
                                      _createElementVNode("div", { class: "error-text" }, "Required", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_227, [
                                _createElementVNode("div", _hoisted_228, [
                                  _createElementVNode("img", {
                                    src: _imports_14,
                                    class: "cursor-pointer",
                                    onClick: ($event: any) => (_ctx.clickedOnDeleteButton(index))
                                  }, null, 8, _hoisted_229)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_230, [
                              _cache[90] || (_cache[90] = _createElementVNode("label", { class: "controllabel" }, "Target Date", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((textarea.targetDate) = $event),
                                type: "date",
                                class: _normalizeClass(["mt-2 w-1/2", {
                                    'inputboxstylingForSelectAtPopup': textarea.targetDate == '',
                                    'stylingForInputboxstylingForSelectAtPopup': textarea.targetDate != '',
                                    'is-invalid borderRed':
                                    _ctx.v$.textareas.$dirty &&
                                    _ctx.v$.textareas.$each.$response.$data[index] &&
                                    _ctx.v$.textareas.$each.$response.$data[index].targetDate &&
                                    !_ctx.v$.textareas.$each.$response.$data[index].targetDate.required,
                                }]),
                                onFocus: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                style: {"height":"28px"},
                                onkeydown: "return false",
                                max: _ctx.todayDate
                              }, null, 42, _hoisted_231), [
                                [_vModelText, textarea.targetDate]
                              ]),
                              (
                                    _ctx.v$.textareas.$dirty &&
                                    _ctx.v$.textareas.$each.$response.$data[index] &&
                                    _ctx.v$.textareas.$each.$response.$data[index].targetDate &&
                                    !_ctx.v$.textareas.$each.$response.$data[index].targetDate.required
                                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_232, _cache[89] || (_cache[89] = [
                                    _createElementVNode("div", { class: "error-text" }, "Target Date is Required", -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[92] || (_cache[92] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    (!_ctx.editVariable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary mr-2",  (JSON.stringify(_ctx.causeActionObj.cause) != JSON.stringify(_ctx.causeActionObjDummy.cause)) || (JSON.stringify(_ctx.textareas) != JSON.stringify(_ctx.textareasDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.cancelCauseAction()))
                          }, "Cancel", 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", (JSON.stringify(_ctx.causeActionObj.cause) != JSON.stringify(_ctx.causeActionObjDummy.cause)) && (JSON.stringify(_ctx.textareas) != JSON.stringify(_ctx.textareasDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveCauseAction()))
                          }, "Save", 10, _hoisted_234)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.editVariable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary mr-2",  (JSON.stringify(_ctx.causeActionObj.cause) != JSON.stringify(_ctx.objDummy.cause)) || (JSON.stringify(_ctx.textareas) != JSON.stringify(_ctx.causeActionObj.actions))  ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.cancelEditedCauseAndAction()))
                          }, "Cancel", 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", (JSON.stringify(_ctx.causeActionObj.cause) != JSON.stringify(_ctx.objDummy.cause)) || (JSON.stringify(_ctx.textareas) != JSON.stringify(_ctx.causeActionObj.actions)) && (_ctx.textareas.length > 0)? 'btnprimary' : 'btndisabled pointer-events-none']),
                            disabled: _ctx.clickOnButton,
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateCauseAndAction(_ctx.causeIdOfCauseAndAction , _ctx.createdAtForUpdate , _ctx.createdByForUpdate)))
                          }, "Save", 10, _hoisted_236)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true),
        (_ctx.showApprovalPopup)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 2,
              popUp: _ctx.showApprovalPopup
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_237, [
                  _cache[94] || (_cache[94] = _createElementVNode("h1", null, "Approval", -1)),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onCrossbtn()))
                  }, _cache[93] || (_cache[93] = [
                    _createElementVNode("img", {
                      src: _imports_17,
                      class: "cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_238, [
                  _createElementVNode("div", _hoisted_239, [
                    _createElementVNode("div", _hoisted_240, [
                      _createElementVNode("div", _hoisted_241, [
                        _createElementVNode("div", _hoisted_242, [
                          _createElementVNode("div", _hoisted_243, [
                            _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                            _createElementVNode("div", _hoisted_244, _toDisplayString(_ctx.getPersonName(_ctx.presentFindingObject.auditor)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_245, [
                          _createElementVNode("div", _hoisted_246, [
                            _cache[96] || (_cache[96] = _createElementVNode("label", { class: "controllabel mt-2" }, "Justification or Comments for Approving", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "inputboxstyling mt-2",
                              placeholder: "Comments",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.taskObj.approvalComments,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[97] || (_cache[97] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_247, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-2", (_ctx.taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary']),
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                      }, "Cancel", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary", (_ctx.taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary']),
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.applyAuthority())),
                        disabled: _ctx.clickOnButtonForApproval
                      }, "Save", 10, _hoisted_248)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true),
        (_ctx.showRejectPopup)
          ? (_openBlock(), _createBlock(_component_popup, { key: 3 }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_249, [
                  _cache[99] || (_cache[99] = _createElementVNode("h1", null, "Justification to Reject the Approval", -1)),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onCrossbtnToCloseRejectionPopup()))
                  }, _cache[98] || (_cache[98] = [
                    _createElementVNode("img", {
                      src: _imports_17,
                      class: "cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_250, [
                  _createElementVNode("div", _hoisted_251, [
                    _createElementVNode("div", _hoisted_252, [
                      _createElementVNode("div", _hoisted_253, [
                        _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel" }, "Justification", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          class: "inputboxstyling mt-2",
                          placeholder: "Comments",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.rejectJustification.justification) = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.rejectJustification.justification,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[101] || (_cache[101] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_254, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-2", 
                _ctx.rejectJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelbtnToReject()))
                      }, " Cancel ", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary", 
                _ctx.rejectJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.approveOrReject(10410))),
                        disabled: _ctx.clickOnButtonForRejectingApproval
                      }, " Save ", 10, _hoisted_255)
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2))
}